module.exports = __webpack_public_path__ + "img/eten-bij-sindy-logo.902650c6.svg";